import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/LOGO_NEWTEC_CLOUD_ICONE_3.png'


const _withScopeId = n => (_pushScopeId("data-v-7470b11f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "radius-7",
    src: _imports_0,
    width: "40",
    alt: "Layer"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ms-10 text-white text-decoration-none title-system-name" }, "Newtec")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "sidebar-menu" }
const _hoisted_7 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-video" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Mosaico de cameras", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play-button" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Gravações", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-download-simple" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Downloads", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-map" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Mapa de Cameras", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-track" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Estacionamento", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-1" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Instalações / Usuários", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-credit-card" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Pagamentos", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-price-tag-2" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Preços", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  class: "mobile-bottom-navigation has-more",
  "aria-label": "Navegação principal"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-video",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ao vivo", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-map",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mapa", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-play-button",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gravações", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-buildings",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Instalações", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-track",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Estacionamento", -1))
const _hoisted_43 = ["aria-expanded"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-dots-three-outline",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mais", -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = { class: "mobile-more-menu-sheet" }
const _hoisted_48 = { class: "mobile-more-menu-header" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mobile-more-menu-eyebrow" }, "Navegação"),
  /*#__PURE__*/_createElementVNode("h2", { id: "mobileMoreMenuTitle" }, "Mais opções")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  class: "mobile-more-menu-grid",
  "aria-label": "Mais opções de navegação"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-download-simple",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Downloads", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-track",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Estacionamento", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-credit-card",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pagamentos", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-price-tag-2",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Preços", -1))
const _hoisted_61 = { class: "mobile-more-menu-item mobile-theme-menu-item" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-moon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Modo escuro", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "flaticon-logout",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sair", -1))
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'desktop-sidebar sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
      id: "sidebar-area"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("button", {
          class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMenuClick()))
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMenuClick())),
            class: "realtime sidebar-nav-item accordion-item bg-transparent border-0 rounded-0 mt-20"
          }, [
            _createVNode(_component_router_link, {
              to: "/realtime",
              class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({ active: _ctx.isRealtimeActive })
                }, _hoisted_10, 2)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleMenuClick())),
            class: "gravacoes sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          }, [
            _createVNode(_component_router_link, {
              to: "/recordings",
              class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({ active: _ctx.isRecordingsActive })
                }, _hoisted_13, 2)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMenuClick())),
            class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          }, [
            _createVNode(_component_router_link, {
              to: "/downloads",
              class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({ active: _ctx.isDownloadsActive })
                }, _hoisted_16, 2)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMenuClick())),
            class: "cam-map sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          }, [
            _createVNode(_component_router_link, {
              to: "/cam-map",
              class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({ active: _ctx.isCamMapActive })
                }, _hoisted_19, 2)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleMenuClick())),
            class: "estacionamento sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          }, [
            _createVNode(_component_router_link, {
              to: "/parking",
              class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({ active: _ctx.isParkingActive })
                }, _hoisted_22, 2)
              ]),
              _: 1
            })
          ]),
          (_ctx.showOptionsAdm)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleMenuClick())),
                class: "documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/installation",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isInstallationActive })
                    }, _hoisted_25, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.showOptionsAdm)
            ? (_openBlock(), _createElementBlock("li", {
                key: 1,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleMenuClick())),
                class: "pagamentos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/payment",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isPaymentActive })
                    }, _hoisted_28, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.showOptionsAdm)
            ? (_openBlock(), _createElementBlock("li", {
                key: 2,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleMenuClick())),
                class: "precos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/prices",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isPricesActive })
                    }, _hoisted_31, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("nav", _hoisted_32, [
      _createVNode(_component_router_link, {
        to: "/realtime",
        class: _normalizeClass(["mobile-navigation-item", { active: _ctx.isRealtimeActive }])
      }, {
        default: _withCtx(() => [
          _hoisted_33,
          _hoisted_34
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/cam-map",
        class: _normalizeClass(["mobile-navigation-item", { active: _ctx.isCamMapActive }])
      }, {
        default: _withCtx(() => [
          _hoisted_35,
          _hoisted_36
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/recordings",
        class: _normalizeClass(["mobile-navigation-item", { active: _ctx.isRecordingsActive }])
      }, {
        default: _withCtx(() => [
          _hoisted_37,
          _hoisted_38
        ]),
        _: 1
      }, 8, ["class"]),
      (_ctx.showOptionsAdm)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/installation",
            class: _normalizeClass(["mobile-navigation-item", { active: _ctx.isInstallationActive }]),
            "aria-label": "Instalações / Usuários",
            title: "Instalações / Usuários"
          }, {
            default: _withCtx(() => [
              _hoisted_39,
              _hoisted_40
            ]),
            _: 1
          }, 8, ["class"]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/parking",
            class: _normalizeClass(["mobile-navigation-item", { active: _ctx.isParkingActive }])
          }, {
            default: _withCtx(() => [
              _hoisted_41,
              _hoisted_42
            ]),
            _: 1
          }, 8, ["class"])),
      _createElementVNode("button", {
        ref: "moreButton",
        type: "button",
        class: _normalizeClass(["mobile-navigation-item mobile-more-button", { active: _ctx.isMoreActive || _ctx.showMoreMenu }]),
        "aria-controls": "mobileMoreMenu",
        "aria-expanded": _ctx.showMoreMenu ? 'true' : 'false',
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openMoreMenu && _ctx.openMoreMenu(...args)))
      }, _hoisted_46, 10, _hoisted_43)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "mobile-menu-sheet" }, {
        default: _withCtx(() => [
          (_ctx.showMoreMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: "mobileMoreMenu",
                ref: "moreMenuDialog",
                class: "mobile-more-menu-backdrop",
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "mobileMoreMenuTitle",
                tabindex: "-1",
                onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeMoreMenu && _ctx.closeMoreMenu(...args)), ["self"])),
                onKeydown: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeMoreMenu && _ctx.closeMoreMenu(...args)), ["esc"]))
              }, [
                _createElementVNode("section", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("button", {
                      type: "button",
                      class: "mobile-more-menu-close",
                      "aria-label": "Fechar mais opções",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeMoreMenu && _ctx.closeMoreMenu(...args)))
                    }, _hoisted_51)
                  ]),
                  _createElementVNode("nav", _hoisted_52, [
                    _createVNode(_component_router_link, {
                      to: "/downloads",
                      class: _normalizeClass(["mobile-more-menu-item", { active: _ctx.isDownloadsActive }])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53,
                        _hoisted_54
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    (_ctx.showOptionsAdm)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: "/parking",
                          class: _normalizeClass(["mobile-more-menu-item", { active: _ctx.isParkingActive }])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_55,
                            _hoisted_56
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true),
                    (_ctx.showOptionsAdm)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: "/payment",
                          class: _normalizeClass(["mobile-more-menu-item", { active: _ctx.isPaymentActive }])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_57,
                            _hoisted_58
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true),
                    (_ctx.showOptionsAdm)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 2,
                          to: "/prices",
                          class: _normalizeClass(["mobile-more-menu-item", { active: _ctx.isPricesActive }])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_59,
                            _hoisted_60
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _hoisted_63,
                      _createVNode(_component_LightDarkSwtichBtn, { class: "mobile-theme-switch" })
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "mobile-more-menu-item mobile-more-menu-logout",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#verticallyCenteredModal",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeMoreMenu && _ctx.closeMoreMenu(...args)))
                    }, _hoisted_66)
                  ])
                ])
              ], 544))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 64))
}